export const OPEN_EDIT_SEQUENCE_MODAL = 'OPEN_EDIT_SEQUENCE_MODAL';
export const OPEN_UNENROLL_SEQUENCE_MODAL = 'OPEN_UNENROLL_SEQUENCE_MODAL';
export const OPEN_VIEW_SEQUENCE_MODAL = 'OPEN_VIEW_SEQUENCE_MODAL';